// --------------------------------------------------------
// src/views/authorCollection.view.js
//
// Manage the view/template of a AuthorCollection object
//
//
// --------------------------------------------------------
"use strict";

// The view for the book collection
const AuthorCollectionComponent = Backbone.View.extend({

    tagName: "ul",

    className: "authors-list p0",

	initialize: function() {
        this.listenTo(this.collection, "update reset delete", this.render);
	},

	// Render the template for every books in the collection
	render: function() {
        this.$el.empty();

        // Render a view for every books in the collection
		this.collection.each(this.addAuthor, this);

		return this;
    },
    
    addAuthor: function(author) {
        let view = new AuthorComponent({ model: author });

        this.$el.append(view.render().el);
    },
});
